<template>
  <div>
    <a-modal
      :title="`已添加${ tableList.length }个参数信息`"
      :width="550"
      :visible="visible"
      :maskClosable="false"
      :footer="null"
      @cancel="close"
    >
      <a-table
        :columns="columns"
        :data-source="tableList"
        :pagination="false"
        row-key="content"
        :scroll="{ y: 180 }"
      >
        <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
          <div :key="item.dataIndex">
            <span>{{ text }}</span>
          </div>
        </template>
      </a-table>
    </a-modal>
    <a-modal
      :title="`已删除${ tableListNew.length }个参数信息`"
      :width="550"
      :visible="visibleNew"
      :maskClosable="false"
      :footer="null"
      @cancel="closeNew"
    >
      <a-table
        :columns="columnsNew"
        :data-source="tableListNew"
        :pagination="false"
        row-key="content"
        :scroll="{ y: 180 }"
      >
        <template v-for="item in columnsNew" :slot="item.dataIndex" slot-scope="text">
          <div :key="item.dataIndex">
            <span>{{ text }}</span>
          </div>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data () {
    return {
      visible: false,
      visibleNew: false,
      columns: [
        {
          title: '参数',
          align: 'center',
          dataIndex: 'content'
        },
        {
          title: '说明',
          align: 'center',
          dataIndex: 'remark'
        }
      ],
      columnsNew: [
        {
          title: '参数',
          align: 'center',
          dataIndex: 'content'
        },
        {
          title: '说明',
          align: 'center',
          dataIndex: 'remark'
        }
      ],
      tableList: [], // 添加
      tableListNew: [] // 删除
    }
  },
  created () {},
  methods: {
    // 添加弹窗
    addShow (val) {
      this.visible = true
      this.tableList = val
    },
    // 删除弹窗
    deleteShow (val) {
      this.visibleNew = true
      this.tableListNew = val
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.tableList = []
    },
    closeNew () {
      this.visibleNew = false
      this.tableListNew = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 300px;
  overflow-y: scroll;
}
</style>
